import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menuProjectCenter",
  "use": "icon-menuProjectCenter-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menuProjectCenter\">\n<path d=\"M1.5 2.99475C1.50137 2.79778 1.58018 2.60926 1.71938 2.46991C1.85859 2.33056 2.04704 2.25157 2.244 2.25H15.756C16.167 2.25 16.5 2.58375 16.5 2.99475V15.0052C16.4986 15.2022 16.4198 15.3907 16.2806 15.5301C16.1414 15.6694 15.953 15.7484 15.756 15.75H2.244C2.04661 15.7498 1.85737 15.6712 1.71787 15.5316C1.57836 15.392 1.5 15.2026 1.5 15.0052V2.99475ZM4.5 11.25V12.75H13.5V11.25H4.5ZM4.5 5.25V9.75H9V5.25H4.5ZM10.5 5.25V6.75H13.5V5.25H10.5ZM10.5 8.25V9.75H13.5V8.25H10.5ZM6 6.75H7.5V8.25H6V6.75Z\" fill=\"#334681\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menuProjectCenter.svg
// module id = zaR8
// module chunks = 111